import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Icon from "@Components/Icon";
import Modal from "@Components/Modal";
import PickupPoint from "@Components/PickupPoint";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import Button from "../../overrides/venia-ui/components/Button";
import classes from "../BookTable/BookForm/bookTableForm.module.scss";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { AddressAutocompleteNoForm } from "@Components/AddressAutocomplete/addressAutocompleteNoForm";
import { getFilteredSortedStores } from "@Src_main/utils/storeConfigs";
import loadGmaps from "@Src_main/utils/GMapsJSImport";
var StoreBookFormModal = _ref => {
  var {
    setSelectedStore,
    isModalSelectionOpen,
    setIsModalSelectionOpen,
    allStores,
    showStoreHours
  } = _ref;
  var {
    isMobile
  } = useWindowSize();
  var {
    formatMessage
  } = useIntl();
  var [choosedPosition, setChoosedPosition] = useState(null);
  var [isGeolocation, setIsGeolocation] = useState(true);
  var addressSetter = useRef();
  var [showMore, setShowMore] = useState({
    items: 20,
    totalItems: 0,
    increase: 20
  });
  var [storesSorted, setStoresSorted] = useState([]);
  var handleValueSetter = setter => {
    addressSetter.current = setter;
  };
  var handleSelectedAddressDetails = details => {
    if (details) {
      setChoosedPosition({
        latitude: details.geometry.location.lat(),
        longitude: details.geometry.location.lng()
      });
    } else setChoosedPosition(null);
    setShowMore(_objectSpread(_objectSpread({}, showMore), {}, {
      items: 20
    }));
  };
  useEffect(() => {
    if (choosedPosition && allStores) {
      var sortedStores = getFilteredSortedStores(allStores, choosedPosition).slice(0, showMore.items);
      setStoresSorted(sortedStores);
    } else if (allStores) {
      var _sortedStores = allStores.slice(0, showMore.items);
      setStoresSorted(_sortedStores);
    }
  }, [choosedPosition, allStores, showMore]);
  var checkPosition = () => {
    if (window.navigator.geolocation) {
      setIsGeolocation(true);
      window.navigator.geolocation.getCurrentPosition(position => {
        var _position$coords, _position$coords2;
        if (position !== null && position !== void 0 && (_position$coords = position.coords) !== null && _position$coords !== void 0 && _position$coords.latitude && position !== null && position !== void 0 && (_position$coords2 = position.coords) !== null && _position$coords2 !== void 0 && _position$coords2.longitude) {
          setChoosedPosition({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
          new google.maps.Geocoder().geocode({
            latLng: new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
          }, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK && addressSetter !== null && addressSetter !== void 0 && addressSetter.current) {
              addressSetter.current(results[0].formatted_address);
            }
          });
        }
      });
    }
  };
  var geolocation = /*#__PURE__*/React.createElement("button", {
    className: "geolocator uk-padding-remove ".concat(classes.geolocator),
    onClick: checkPosition
  }, isGeolocation ? /*#__PURE__*/React.createElement(Icon, {
    name: "icon-geolocator",
    color: "white"
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "icon-geolocator",
    color: "black",
    header: true
  }));
  useEffect(() => {
    loadGmaps(checkPosition);
  }, []);
  return /*#__PURE__*/React.createElement(Modal, {
    id: "modal-store-selection",
    nameClass: "modal-store-selection",
    modalDialogClass: "".concat(isMobile ? "section-rounded uk-position-bottom " : "uk-position-center uk-border-rounded  "),
    animation: "".concat(isMobile ? "uk-animation-slide-bottom" : "uk-animation-scale-up"),
    modalCloseOutside: true,
    isOpen: isModalSelectionOpen,
    onClose: () => {
      setIsModalSelectionOpen(false);
    }
  }, storesSorted.length ? /*#__PURE__*/React.createElement("div", {
    className: "uk-overflow-auto uk-height-xlarge"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "uk-margin-top-small uk-align-center uk-padding uk-margin-bottom uk-padding-remove-vertical uk-margin-small-top uk-text-uppercase uk-text-center"
  }, formatMessage({
    id: "book.table.store.selection"
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-padding uk-margin-bottom uk-padding-remove-vertical uk-flex uk-flex-center uk-text-center search"
  }, /*#__PURE__*/React.createElement(AddressAutocompleteNoForm, {
    field: "address",
    fullAddress: true,
    before: /*#__PURE__*/React.createElement(Icon, {
      name: "icon-position",
      color: "miscusi-red"
    }),
    getValueSetter: handleValueSetter,
    getSelectedAddressDetails: handleSelectedAddressDetails,
    onChange: e => e.target.value.trim() === "" ? handleSelectedAddressDetails(null) : null
  }), geolocation), /*#__PURE__*/React.createElement("div", {
    className: "uk-padding uk-overflow-auto uk-height-large uk-flex-nowrap uk-flex uk-grid uk-grid-small uk-flex-column",
    style: {
      msOverflowStyle: "none",
      scrollbarWidth: "thin"
    },
    "data-uk-grid": true
  }, storesSorted.map(store => /*#__PURE__*/React.createElement("div", {
    key: store.ls_store_id
  }, /*#__PURE__*/React.createElement(PickupPoint, {
    selectable: true,
    onSelect: () => {
      setIsModalSelectionOpen(false);
      setSelectedStore(store);
    },
    store: store,
    choosedPosition: choosedPosition,
    showStoreHours: showStoreHours,
    showDetailModal: true
  })))), storesSorted.length > allStores.length ? /*#__PURE__*/React.createElement(Button, {
    onClick: () => setShowMore(_objectSpread(_objectSpread({}, showMore), {}, {
      items: showMore.items + showMore.increase
    })),
    color: "outline",
    extraClass: "uk-align-center",
    fullScreen: false,
    style: {
      marginTop: "30px"
    }
  }, formatMessage({
    id: "restaurant.load.stores"
  })) : null) : null);
};
export default StoreBookFormModal;